
(function($) {
	$.GPRKernel = function(type, params) {
		this._type = type;

		if (type == "rbf") {
			this._length_scale = params.k_length_scale;
		}
	};

	$.GPRKernel.prototype = {
		_sqeuc: function(x,y) { 
			// compute the squared euclidean distance
			// note: x and y are supposed to be of the same length
			var n,sum;

			n = x.length;
			sum = 0.0;

			for (i = 0; i < n; i++) {
				sum += Math.pow(x[i] - y[i], 2.0);
			}

			return sum;
		},

		_sqeucdist: function(X, Y) {
			var m,n,i,j;

			m = X.length;
			n = Y.length;

			dists = new Array(m);
			for (i = 0; i < m; i++) {
				dists[i] = new Array(n);
				for(j = 0; j < n; j++) {
					dists[i][j] = this._sqeuc(X[i], Y[j]);
				}
			}

			return dists;
		},

		/**
		 * Scales X by 1/scale
		 * @param {*} X (m,n) Array
		 * @param {*} scale numbe or (1,n) Array
		 * @returns 
		 */
		_scale_matrix: function(X, scale) {
			
			var i,j,result,anisotropic; 
			
			anisotropic = Array.isArray(scale);

			result = new Array(X.length);
			for (i = 0; i < X.length; i++) {
				result[i] = new Array(X[i].length);
				for (j = 0; j < X[i].length; j++) {
					if (anisotropic) {
						result[i][j] = X[i][j]/scale[0][j];
					}
					else {
						result[i][j] = X[i][j]/scale;
					}
				}
			}

			return result;
		},

		_exp_kernel: function(X, Y, scale) { 
			var dists = this._sqeucdist(this._scale_matrix(X, scale), this._scale_matrix(Y, scale));

			var i,j,K;
			K = new Array(dists.length);
			for (i = 0; i < dists.length; i++) {
				K[i] = new Array(dists[i].length);
				for (j = 0; j < K[i].length; j++) {
					K[i][j] = Math.exp(-0.5 * dists[i][j]);
				}
			}

			return K;
		},

		_validate_input: function(X) {
			// if array is 1D, return a 2D array
			var n = X.length;

			if (n > 0 && !Array.isArray(X[0]))  {
				return [X];
			}
			else {
				return X;
			}
		},

		apply: function(X,Y) {
			var K_trans;

			X = this._validate_input(X);

			switch(this._type) {
				case "rbf":
					K_trans = this._exp_kernel(X, Y, this._length_scale);
					break; 
				default:
					console.error("Unsupported kernel: " + this._type);
					break;
			}

			return K_trans;
		},

	};
	
	// module to load models trained in scikit-learn and execute them in the browser
	$.GPRModel = function(input, parameters, kernel_type) {
		this._input = input;
		this._parameters = parameters;
		this._kernel_type = kernel_type;
		this._kernel = new $.GPRKernel(kernel_type, parameters);
	};

	$.GPRModel.prototype = {
		_dotprod: function(X,Y) {
			// dot product of 1-d arrays
			// assumption: X and Y are of the same length
			var n = X.length;
			var sum = 0.0;
			for (i = 0; i < n; i++) {
				sum += X[i] * Y[j];
			}

			return sum;
		},

		_matmul: function(X, Y) {
			var x_rows = X.length;
			var x_cols = X[0].length;
			var y_rows = Y.length;
			var y_cols = Y[0].length;

			if (x_cols != y_rows) {
				throw "x_cols != y_rows (" + x_cols + " != " + y_rows + ")";
			} 

			var i,j,k,l;
			var res = new Array(x_rows);
			for (i = 0; i < x_rows; i++) {
				res[i] = new Array(y_cols);
				for (j = 0; j < y_cols; j++) {

					// row-col vector wise dot product
					res[i][j] = 0.0;
					for (k = 0; k < x_cols; k++) { 
						res[i][j] += X[i][k] * Y[k][j]; 
					}	
				} 
			}

			return res;
		},

		predict: function(X) {
			// get transformed input using the GPR kernel
			var K_trans = this._kernel.apply(X, this._input);
			var prediction_mean = this._matmul(K_trans, this._parameters.alpha)[0];

			// unscale
			prediction_mean = this._parameters.std * prediction_mean + this._parameters.mean;

			return prediction_mean;	
		},
	};

	$.GPSMappingGPR = function(params) {
		this._initialized = false;

		// if there is a url in the params load from it
		this.url = params.url || "";
		if (this.url) {
			this._load_from_url(this.url);
			return;
		}
		
		if ("trained_data" in params) {
			this._initialize(params);
		}

	};

	$.GPSMappingGPR.prototype = { 
		to_vp: function(projx, projy) {
			var input = [projx, projy];
			return [this._models.proj2vpx.predict(input), this._models.proj2vpy.predict(input)];
		},

		to_proj: function(x, y) {
			var input = [x, y];
			return [this._models.vp2projx.predict(input), this._models.vp2projy.predict(input)];
		},

		_initialize: function(data) {
			if (!data) {
				return;
			}
			
			this._kernel_type = data.kernel; 

			this._models = {
				vp2projx: new $.GPRModel(data.trained_data.xy, data.trained_data.vp2mercx, this._kernel_type),
				vp2projy: new $.GPRModel(data.trained_data.xy, data.trained_data.vp2mercy, this._kernel_type),
				proj2vpx: new $.GPRModel(data.trained_data.merc_xy, data.trained_data.mercxy2x, this._kernel_type),
				proj2vpy: new $.GPRModel(data.trained_data.merc_xy, data.trained_data.mercxy2y, this._kernel_type),
			};

			this._initialized = true;
		},

		_load_from_url: function(url) {
			var request = new XMLHttpRequest(); 
			request.addEventListener('load', this._data_requested.bind(this, request, url)); 
			request.open('GET', url);
			request.send();

			abdo_osd.addCache(url);
		},

		_data_requested: function(request, url, event) {
			if (request.status == 0 || (request.status >= 200 && request.status < 400)) {
				var json_data = null; 
				try {
					json_data = JSON.parse(request.responseText);
					console.dir(json_data);
				}
				catch(e) {
					console.error("Error parsing JSON data from " + url); 
				}
               
                this._initialize(json_data); 
            }
		}, 
	};

})(ABDOMap);